// Global Instructions Rule Applied!
//
// Configuration → Pipeline Statuses admin model: one cfg.pipeline_statuses
// row plus usage_count (live references across pipeline_stages, comms rules,
// the follower exclusion arrays and the app_config status lists) — what the
// delete guard counts (usage > 0 forces the Replace flow).
// Shape mirrors public.view__pipeline_statuses.
import { z } from 'zod'
import { validateWithZodSchema } from '../../core/utils/utilities.ts'

// The three category slugs and their labels used to be mirrored here from the
// CHECK constraint. Both are gone: a status now belongs to a
// cfg.pipeline_types ROW (20261111120100), so the vocabulary comes from
// globalConfigs and a fourth pipeline kind needs no frontend change.

export const PipelineStatusAdminRowSchema = z
  .object({
    pipeline_statuses__id: z.string(),
    pipeline_statuses__name: z.string(),
    pipeline_statuses__pipeline_type_id: z.string(),
    pipeline_types__name: z.string().nullish(),
    pipeline_types__type_key: z.string().nullish(),
    // Has the process ended here, and what does it end as — independent, and
    // both needed: a live status carries the outcome it would resolve to on a
    // fund close without having reached it (cfg.pipeline_outcomes).
    pipeline_statuses__is_terminal: z.boolean(),
    pipeline_statuses__outcome_id: z.string().nullish(),
    pipeline_outcomes__label: z.string().nullish(),
    pipeline_outcomes__outcome_key: z.string().nullish(),
    pipeline_outcomes__tag_color: z.string().nullish(),
    pipeline_statuses__sort_order: z.number().nullish(),
    pipeline_statuses__usage_count: z.number(),
    pipeline_statuses__date_modified: z.string().nullish()
  })
  .strict()

export type PipelineStatusAdminRow = z.infer<typeof PipelineStatusAdminRowSchema>

export function validatePipelineStatusAdminRow(
  data: unknown,
  options?: { isArray?: boolean }
): PipelineStatusAdminRow | PipelineStatusAdminRow[] {
  try {
    return validateWithZodSchema(
      PipelineStatusAdminRowSchema,
      data,
      'pipeline status admin row',
      options
    ) as PipelineStatusAdminRow | PipelineStatusAdminRow[]
  } catch (e) {
    throw new Error(`Pipeline status validation failed: ${e}`)
  }
}
